/**<params config data>说明
 * position 文本框位置：string  left  right  top  bottom
 * isShowLogo 控制 EcoFlow logo 显示
 * titleFontSize 标题字号
 * desFontSize 简介字号
 * theme 决定文本跟logo颜色：white black
 */
import EFVideoModal, { PlayerType } from '@/components/UI/EFVideoModal';
import Image from '@/components/UI/Image';
import BsFillTriangleFill from '@/components/UI/svg/Icons/BsFillTriangleFill';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { FunctionComponent } from 'react';
import css from './index.module.scss';
interface PropsType {
    config?: ConfigType;
    data: DataType[];
}
type ConfigType = {
    position?: 'top' | 'left' | 'right' | 'bottom';
    isShowLogo?: boolean;
    titleFontSize?: number;
    desFontSize?: number;
    theme?: 'white' | 'black';
    isShowVideo?: boolean;
    webpUrl?: string;
};
type DataType = {
    bgImgs?: string | string[];
    title?: string;
    suffix?: string;
    des?: string;
    video_src?: string;
};

const configs: ConfigType = {
    position: 'top',
    isShowLogo: true,
    titleFontSize: 0.32,
    desFontSize: 0.17,
    theme: 'white',
    isShowVideo: false,
};
const itemsData: DataType[] = [
    {
        bgImgs: '/img/banner-delta.png',
        title: 'RIVER',
        suffix: '',
        des: 'Live without limits with the portable home battery',
        video_src: 'https://www.youtube.com/embed/ozVzv0jo_BM',
    },
];

const BannerModule: FunctionComponent<PropsType> = (props) => {
    const configTypes = { ...configs, ...props.config };
    const { EFPic } = createEFPic(configTypes?.webpUrl);
    const data = props.data || itemsData;
    const { useEffect, useState, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('shared');
    const { locale } = useRouter();
    const logoImgLocal = getImageLocal(locale, ['cn']);
    const [isIos, setIsIos] = useState(false);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    useEffect(() => {
        const app = navigator.userAgent;
        setIsIos(/Mac OS X/gi.test(app));
    }, []);
    const [curVideo, setCurVideo] = useState('');
    const toggleVideo = (item: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: item.title,
            position: item.title,
        });
        setShowEFVideoModal(!showEFVideoModal);
        if (item.video_src) setCurVideo(item.video_src);
    };
    //备注:对于使用Image渲染的满屏图片,如果使用rem,那么，在750px以上宽度变化时,它的高度会保持不变,因此使用vw更为合适
    //整体高度问题:在视频时,应该采用不设置高度,容器大小随视频而变化
    return (
        <div className={`${css.BannerModule} bannerModule`}>
            {data.map((item: any) => (
                <div className={`box`} key={item.title}>
                    <div className="bg">
                        {Array.isArray(item.bgImgs) ? (
                            <EFPic name={item.bgImgs} alt={item.title + item.suffix} />
                        ) : (
                            <Image src={item.bgImgs} layout="fill" className="fullImgs" alt={item.title + item.suffix} />
                        )}
                    </div>
                    <div
                        className={`msgBox ${isIos ? 'iphone-text' : ''} ${configTypes.position === 'top' ? 'topPosition' : 'bottomPosition'} ${
                            configTypes.isShowVideo ? 'videoBox' : ''
                        }`}
                    >
                        <div className="content">
                            <span style={{ display: configTypes.isShowLogo ? 'block' : 'none' }} className="signFullImgsBox">
                                <Image
                                    src={configTypes.theme === 'white' ? `/img/logo_white_${logoImgLocal}.png` : `/img/logo_black_${logoImgLocal}.png`}
                                    layout="fill"
                                    alt={item.title}
                                />
                            </span>
                            <div
                                className="title"
                                style={{
                                    fontSize: `${configTypes.titleFontSize}rem`,
                                    color: configTypes.theme === 'white' ? '#fff' : '#000',
                                }}
                            >
                                {item.title}{' '}
                                <p className="suffix font-family-regular" style={{ display: item.suffix ? 'inline-block' : 'none' }}>
                                    {item.suffix}
                                </p>
                            </div>
                            <p
                                className="des font-family-semibold"
                                style={{
                                    fontSize: `${configTypes.desFontSize}rem`,
                                    color: configTypes.theme === 'white' ? '#fff' : '#000',
                                }}
                            >
                                {item.des}
                            </p>
                            {configTypes.isShowVideo && (
                                <button
                                    id="btnWatchVideo"
                                    onClick={() => toggleVideo(item)}
                                    className="videoButton"
                                    style={{
                                        color: configTypes.theme === 'white' ? '#fff' : '#000',
                                        borderColor: configTypes.theme === 'white' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
                                    }}
                                    aria-label={t('watch_video')}
                                >
                                    <div>{t('watch_video')}</div>
                                    <BsFillTriangleFill className="arrow-triangle-right" />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            ))}
            <EFVideoModal
                visible={showEFVideoModal}
                source={curVideo}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? PlayerType.Alibaba : PlayerType.YouTube}
            />
        </div>
    );
};

export default BannerModule;
